<div class="modal-container page-content property">
  <div class="modal-header border-0 d-flex justify-content-between">
    <h5 class="modal-heading">Add a Card</h5>
    <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">
      &times;
    </p>
  </div>
  <div class="modal-body">
    <app-input-debit-card
      #stripePayment
      (paymentSuccess)="paymentSuccess($event)"
    ></app-input-debit-card>
    <div class="d-flex justify-content-between align-items-center my-3">
      <p class="sub mt-3">
        <fa-icon class="me-2 info-icon" [icon]="icons.lock"></fa-icon>
        Secure Payments
      </p>
      <div class="d-flex">
        <img class="ms-3" src="assets/resource/stripe-pw-cards.svg" />
        <img class="ms-3" width="25px" src="assets/icons/confidence.png" />
      </div>
    </div>
    <div>
      <app-button
        dataTest="save-and-close-btn"
        [className]="'w-100'"
        (onclick)="handleAddCard()"
        [disabled]="loading"
        warning
      >
        {{ loading ? "Saving..." : "Save & Close" }}
      </app-button>
    </div>
  </div>
</div>
